import React, { PureComponent } from "react";
import NextIcon        from "../svg/next";
import classnames      from "classnames";
import StatusIndicator from "./status-indicator";
import "./list-item.css";

export default class ListItem extends PureComponent {
    static get defaultProps () {
        return {
            isActive: false,
            hasStatusIndicator: false,
            onClick: null,
        };
    }

    static get propTypes() {
        return {
            isActive: React.PropTypes.bool,
            onClick: React.PropTypes.func,
            hasStatusIndicator: React.PropTypes.bool,
            children: React.PropTypes.oneOfType([
                React.PropTypes.element,
                React.PropTypes.string
            ]).isRequired
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    handleClick() {
        if (this.props.onClick !== null && this.props.isActive) {
            this.props.onClick();
        }
    }

    render() {
        const styles = ["appointment-list-item"];

        if (this.props.isActive === false) {
            styles.push("appointment-list-item--inactive");
        }

        return (
            <div className={classnames(styles)} onClick={() => this.handleClick()}>
                {this.props.hasStatusIndicator === true ? <div className="appointment-list-item__status-indicator">
                    <StatusIndicator isActive={this.props.isActive} />
                </div> : null}

                <div className="appointment-list-item__content">
                    {this.props.children}
                </div>

                {this.props.isActive === true ? <div className="appointment-list-item__next-icon">
                    <NextIcon color={"#adadad"} />
                </div> : null}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/list-item.js
 **/